import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextError, colorTextMedium, space2 } = theme();

  return StyleSheet.create({
    discountedPercentage: {
      color: colorTextError,
    },
    discountedPriceInfo: {
      alignItems: "flex-end",
      marginLeft: space2,
    },
    discountedPriceText: {
      color: colorTextMedium,
      textDecorationLine: "line-through",
    },
    price: {
      flexDirection: "row",
    },
  });
};

export { style };
